module.exports = __webpack_public_path__ + "static/media/big_check_mark.4f8212d1.svg";